
// tslint:disable: max-classes-per-file
import Vue from 'vue';

function copy(distObj: any, sourceObj: any) {
    for (const key in distObj) {
        if (['subscribers'].indexOf(key) === -1 && !(distObj[key] instanceof Function)) {
            if (distObj[key] instanceof Object) {
                copy(distObj[key], sourceObj[key] || {});
            } else {
                distObj[key] = sourceObj[key] || '';
            }
        }
    }
}

export class Localization {
    // [id: string]: string | any;

    public Loading: string = '';
    public Button = new class ButtonLocalization {
        public Cancel: string = '';
    }();
    public CargoPlacement = new class CargoPlacementLocalization {
        public Cargo: string = '';
        public Containers: string = '';
        public General: string = '';
        public GroupObjects: string = '';
        public SchemePicker = new class SchemePickerLocalization {
            public Add: string = '';
            public Edit: string = '';
            public Remove: string = '';
            public Save: string = '';
        }();
        public Objects = new class ObjectsLocalization {
            public Area: string = '';
            public Pack: string = '';
            public Rack: string = '';
            public Storage: string = '';
        }();
    }();
    public Dialog = new class DialogLocalization {
        public AreYouSure: string = '';
    }();
    public LogisticWorkplace = new class LogisticWorkPlaceLocalization {
        public PageLabel: string = '';
        public ResourceColumn: string = '';
        public LinkedResourceColumn: string = '';
        public LocationColumn: string = '';
        public TimeSpanColumn: string = '';
        public DurationColumn: string = '';
        public ResourceTypeColumn: string = '';
        public AreaPlacesColumn: string = '';
        public ChooseSite: string = '';
        public Remove: string = '';
        public Approve: string = '';
        public Recalc: string = '';
    }();
    public ContextSettingsPage = new class ContextSettingsPageLocalization {
        public AcceptableLoad: string = '';
        public Button = new class ButtonLocalization {
            public Change: string = '';
        }();
        public CheckLessLimitedRoutes: string = '';
        public CollectSchedulingData: string = '';
        public CollectSolutions: string = '';
        public ConsiderPreviousChecks: string = '';
        public CraneIdleTimeout: string = '';
        public CurrentTime: string = '';
        public DemandDivisibility: string = '';
        public EarlyDeliveryTimespan: string = '';
        public EnableStockConsolidationSelector: string = '';
        public FixedCranes: string = '';
        public MaxCraneOperationDuration: string = '';
        public MaxDemandDelay: string = '';
        public MobileCranes: string = '';
        public Name: string = '';
        public NonTransferrableStock: string = '';
        public Objective: string = '';
        public OperationsLimit: string = '';
        public ProcessContextTimeout: string = '';
        public QuantityDifferenceTolerance: string = '';
        public ResourceSavingBorder: string = '';
        public RoutesLimit: string = '';
        public ScheduleOffset: string = '';
        public ScheduleHorizon: string = '';
        public SchedulingTimeLimit: string = '';
        public SignificantDelay: string = '';
        public StrictConsignmentMatch: string = '';
        public StrictObjectMatch: string = '';
        public Type: string = '';
        public WaitMoreLoadsTimeSpan: string = '';
        public ValuePrecision: string = '';
        public RelocationWithoutLoading: string = '';
    }();
    public UserSettingsPage = new class UserSettingsPageLocalization {
        public PageLabel: string = '';
        public Version: string = '';
        public Button = new class ButtonLocalization {
            public Help: string = '';
            public LogOut: string = '';
            public Reset: string = '';
        }();
        public CultureComponent = new class CultureComponentLocalization {
            public Language: string = '';
        }();
        public UserSettingsComponent = new class UserSettingsComponentLocalization {
            public Level: string = '';
            public SaveForLevel: string = '';
            public ResetForLevel: string = '';
            public ForUser: string = '';
            public ForRole: string = '';
            public Main: string = '';
            public AlignOffset: string = '';
            public TimeOffset: string = '';
            public HistoryHorizon: string = '';
            public ExternalDataRegex: string = '';
            public FormatDate: string = '';
            public FormatTime: string = '';
            public FormatWeight: string = '';
            public FormatVolume: string = '';
            public FormatArea: string = '';
            public FormatCurrency: string = '';
            public FormatNumber: string = '';
            public SiteGroups: string = '';
            public ProductPackCount: string = '';
            public OrderingField: string = '';
            public ItemCount: string = '';
            public ItemVolume: string = '';
            public ItemWeight: string = '';
            public MapObjectIcons: string = '';
            public SiteIconSizeMultiplier: string = '';
            public StartShiftTime: string = '';
            public SaveTileState: string = '';
            public ColorIndication: string = '';
            public PropertyEnableNotifications: string = '';
            public PropertyEnableGroupNotifications: string = '';
            public PropertyEnableTableColumnHeaderWordWrap: string = '';
            public AutoReconnect: string = '';
            public Indicators: string = '';
            public AvailableIndicators: string = '';
            public IndicatorGroup: string = '';
            public SelectedIndicators: string = '';
            public ListTableStates: string = '';
            public ResultSuccess: string = '';
            public ResultError: string = '';
            public ChangeLevel: string = '';
            public UrlMap: string = '';
            public ClientSettingsType = new class ClientSettingsTypeLocalization {
                public Context: string = '';
                public ContextRole: string = '';
                public ContextType: string = '';
                public ContextUser: string = '';
                public Default: string = '';
                public Summary: string = '';
                public UserOfContextType: string = '';
            }();
        }();
    }();

    private subscribers: Array<any> = [];
    public subscribeDataChanging(vm: typeof Vue) {
        this.subscribers.push(vm);
    }
    public unsubscribeDataChanging(vm: typeof Vue) {
        if (this.subscribers.length) {
            const index = this.subscribers.indexOf(vm);
            if (index > -1) {
                this.subscribers.splice(index, 1);
            }
        }
    }
    public async setLocale(localization: any = {}) {
        copy(this, localization);
        for (const vm of this.subscribers) {
            vm.$forceUpdate();
        }
    }
}
